import Controller from '@ember/controller';
import { DASHBOARD_URL } from '@banking/ui/utils/constants';

export default class Forbidden extends Controller {
  dashboardUrl = DASHBOARD_URL;
}
